import React from "react";
import { Route, Link } from "react-router-dom";
const LectureItem = props => {
  return (
    <li>
      <div class="timeline-time ">
        <span class="date">
          {props.dayName}{" "}
          <span class="badge badge-primary">{props.item.slotNo}</span>
        </span>
        <span class="time">
          {props.item.from} {props.item.to}
        </span>
      </div>
      <div className={`timeline-icon`}>
        <a href="javascript:;" />
      </div>

      <div className={`timeline-body `}>
        {/* bg-${props.item.className} */}
        <div class="timeline-header">
          <span class="username">
            <Link to={`/course/${props.item.crsnum}/`}>
              {props.item.crsName}
            </Link>

            <small />
          </span>
          <span class="pull-right text-muted">{props.item.lectType}</span>
        </div>

        <div class="location_type">
          <span />
          <span class="type"> </span>
          <span class="location">Room {props.item.roomNo}</span>
        </div>
      </div>
    </li>
  );
};

export default LectureItem;



// WEBPACK FOOTER //
// ./src/pages/student_schedule/LectureItem.js